export default __webpack_public_path__ + "static/media/AndhraPradesh_4.9ff39331.png";